(function () {
    class HowlerAudioPlayer  {

        constructor(settings) {
           this.sounds = [];
        }

        initialize(definitions) {
            definitions.forEach(settings => {
                this.sounds.push(this.createSound(settings.id, settings));
            })
        }

        createSound(id, options) {
            const sound = new Howl({
                src: options.src,
                autoplay: options.autoplay,
                loop: options.loop,
                volume: options.volume || 0.5
                // onend hook...
            })

            return { id, sound, options };
        }

        getSoundById(id) {
            return this.sounds.find(s => s.id === id);
        }

        hasSound(id) {
            return this.sounds.some(s => s.id === id);
        }

        doIfSound(id, cb) {
            const soundEntity = this.getSoundById(id);
            if (soundEntity) return cb(soundEntity);
            return null;
        }


        play(id, options) {
            this.doIfSound(id, (soundEntity) => {
                if (options.multiple) {
                    soundEntity.sound.play();
                } else if (!soundEntity.sound.playing()) {
                    soundEntity.sound.play();
                }
            });
        }

        mute(id, value) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.mute(value);
            });
        }

        fade(id, { volume = 0, time = 0 }) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.fade(soundEntity.sound.volume() || 0, volume, time);
            });
        }

        pause(id) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.pause();
            });
        }
        stop(id) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.stop()
            });
        }
        volume(id, value) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.volume(value);
            });
        }
        rate(id, value) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.rate(value);
            });
        }
        seek(id, value) {
            this.doIfSound(id, (soundEntity) => {
                soundEntity.sound.seek(value);
            });
        }
        playing(id) {
            return this.doIfSound(id, (soundEntity) => {
                return soundEntity.sound.playing()
            });
        }
        duration(id) {
            return this.doIfSound(id, (soundEntity) => {
                return soundEntity.sound.duration()
            });
        }
    }


    touchKit.AudioStrategyManager.registerStrategy("howler", () => {
        return new HowlerAudioPlayer();
    });
}())